var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import * as ServiceSectorisation from '../../services/sectorisation';
import * as ServiceUtils from '../../services/utils';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import { Typography } from '../../utils/Typography';
import { Loader } from '../../utils/Loader';
import { CollaborateurIcon, DeleteIcon, EquipeIcon, ExpandIcon, MoveIcon, RightIcon, StarIcon, } from '../../utils/Icons';
import { IconButton } from '../../utils/IconButton';
import { Stack } from '@mui/material';
import { FormikGenerator, TYPES } from '../../utils/FormikGenerator';
import { ConfirmDialog } from '../../utils/ConfirmDialog';
import { SectorisationSchema } from '../../utils/ValidationSchema';
import { CardTitle } from '../../utils/CardTitle';
var OBJECT = {
    COLLABORATEUR: 'Collaborateur',
    GROUPE: 'Groupe',
};
var KEY_SEPARATOR = '_';
var KEY_PARENT = OBJECT.GROUPE + KEY_SEPARATOR + 'Parent';
export var Sectorisation = function () {
    var _a = useState([KEY_PARENT]), expanded = _a[0], setExpanded = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState([]), sectorisations = _c[0], setSectorisations = _c[1];
    var _d = useState([]), groupes = _d[0], setGroupes = _d[1];
    var _e = useState([]), collaborateurs = _e[0], setCollaborateurs = _e[1];
    var getData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var datas;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        ServiceSectorisation.getSectorisation(),
                        ServiceUtils.getTypes('Groupe'),
                        ServiceUtils.getSelectOptions('collaborateurs'),
                    ])];
                case 1:
                    datas = _a.sent();
                    setSectorisations(datas[0]);
                    setGroupes(datas[1]);
                    setCollaborateurs(datas[2]);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        getData();
    }, [getData]);
    var handleToggle = function (e, nodes) {
        if (nodes) {
            setExpanded(nodes);
        }
    };
    var renderTreeItem = function (sectos, values) {
        return (_jsx(_Fragment, { children: sectos.map(function (secto) {
                var Icon = StarIcon;
                if (secto.Objet === OBJECT.COLLABORATEUR) {
                    Icon = CollaborateurIcon;
                }
                else if (secto.Objet === OBJECT.GROUPE) {
                    Icon = EquipeIcon;
                }
                return (_jsx(TreeItem, __assign({ nodeId: secto.Objet + KEY_SEPARATOR + secto.IdSectorisation.toString(), label: _jsxs(Stack, __assign({ direction: "row", justifyContent: "space-between", p: 1 }, { children: [_jsx(Typography, __assign({ startIcon: _jsx(Icon, {}) }, { children: secto.Libelle })), _jsxs(Stack, __assign({ direction: "row", alignItems: "center" }, { children: [secto.Objet === OBJECT.GROUPE && values.ParentId && (_jsx(IconButton, __assign({ tooltip: "D\u00E9placer ici", color: "neutre", onClick: function () { return handleClickMove(secto, values.ParentId); } }, { children: _jsx(MoveIcon, {}) }))), secto.sectorisations && secto.sectorisations.length > 0 ? (_jsxs(Typography, { children: ["(", secto.sectorisations.length, ")"] })) : (_jsx(IconButton, __assign({ tooltip: "Supprimer", color: "error", onClick: function () { return handleClickDelete(secto); } }, { children: _jsx(DeleteIcon, {}) })))] }))] })) }, { children: secto.sectorisations &&
                        secto.sectorisations.length > 0 &&
                        renderTreeItem(secto.sectorisations, values) }), secto.IdSectorisation));
            }) }));
    };
    var handleClickMove = function (secto, idItemMove) { return __awaiter(void 0, void 0, void 0, function () {
        var confirmation;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ConfirmDialog({
                        title: 'Confirmation',
                        content: "\u00CAtes-vous s\u00FBr de vouloir d\u00E9placer cette sectorisation".concat(secto ? " dans \"".concat(secto.Libelle, "\"") : '', " ?"),
                        color: 'warning',
                    })];
                case 1:
                    confirmation = _a.sent();
                    if (!confirmation.isOk) return [3 /*break*/, 3];
                    return [4 /*yield*/, ServiceSectorisation.moveSectorisation(idItemMove, secto ? secto.IdSectorisation : null)];
                case 2:
                    _a.sent();
                    getData();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleClickDelete = function (secto) { return __awaiter(void 0, void 0, void 0, function () {
        var confirmation;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ConfirmDialog({
                        title: 'Suppression',
                        content: 'Êtes-vous sûr de vouloir supprimer cette sectorisation ?',
                        color: 'error',
                    })];
                case 1:
                    confirmation = _a.sent();
                    if (!confirmation.isOk) return [3 /*break*/, 3];
                    return [4 /*yield*/, ServiceSectorisation.deleteSectorisation(secto.IdSectorisation)];
                case 2:
                    _a.sent();
                    getData();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return loading ? (_jsx(Loader, {})) : (_jsx(Stack, __assign({ p: 4 }, { children: _jsx(FormikGenerator, { datas: {
                CandAdd: false,
                ParentId: null,
                Objet: OBJECT.COLLABORATEUR,
                CollaborateurId: null,
                GroupeId: null,
            }, validationSchema: SectorisationSchema, onSubmit: function (newSectorisation, _a) {
                var resetForm = _a.resetForm;
                return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (newSectorisation.Objet === OBJECT.COLLABORATEUR) {
                                    newSectorisation.ObjetId = newSectorisation.CollaborateurId;
                                }
                                if (newSectorisation.Objet === OBJECT.GROUPE) {
                                    newSectorisation.ObjetId = newSectorisation.GroupeId;
                                }
                                delete newSectorisation.CollaborateurId;
                                delete newSectorisation.GroupeId;
                                return [4 /*yield*/, ServiceSectorisation.postSectorisation(newSectorisation)];
                            case 1:
                                _b.sent();
                                getData();
                                resetForm();
                                return [2 /*return*/];
                        }
                    });
                });
            }, submitLabel: "Ajouter", renderHeader: function (_a) {
                var values = _a.values, setFieldValue = _a.setFieldValue;
                return (_jsxs(_Fragment, { children: [_jsx(TreeView, __assign({ className: "mb-large", defaultCollapseIcon: _jsx(ExpandIcon, {}), defaultExpandIcon: _jsx(RightIcon, {}), multiSelect: false, expanded: expanded, onNodeToggle: handleToggle, onNodeSelect: function (e, newParentId) {
                                setFieldValue('CandAdd', newParentId.split(KEY_SEPARATOR)[0] === OBJECT.GROUPE);
                                setFieldValue('ParentId', newParentId.split(KEY_SEPARATOR)[1]);
                            } }, { children: _jsx(TreeItem, __assign({ nodeId: KEY_PARENT, label: _jsxs(Stack, __assign({ direction: "row", justifyContent: "space-between", p: 1 }, { children: [_jsx(Typography, __assign({ startIcon: _jsx(StarIcon, {}) }, { children: process.env.REACT_APP_NAME })), _jsxs(Stack, __assign({ direction: "row", alignItems: "center" }, { children: [values.ParentId && (_jsx(IconButton, __assign({ tooltip: "D\u00E9placer ici", color: "neutre", onClick: function () {
                                                        return handleClickMove(null, values.ParentId);
                                                    } }, { children: _jsx(MoveIcon, {}) }))), _jsxs(Typography, { children: ["(", sectorisations.length, ")"] })] }))] })) }, { children: renderTreeItem(sectorisations, values) })) })), values.CandAdd && (_jsx(CardTitle, { className: "mb-small", title: "Ajouter sectorisation" }))] }));
            }, fields: [
                [
                    {
                        xs: 6,
                        label: 'Type',
                        name: 'Objet',
                        type: TYPES.SELECT,
                        options: [
                            { label: OBJECT.COLLABORATEUR, value: OBJECT.COLLABORATEUR },
                            { label: OBJECT.GROUPE, value: OBJECT.GROUPE },
                        ],
                        show: function (values) { return values.ParentId && values.CandAdd; },
                    },
                    {
                        xs: 6,
                        label: 'Collaborateur',
                        name: 'CollaborateurId',
                        type: TYPES.SELECT,
                        options: collaborateurs,
                        show: function (values) {
                            return values.ParentId &&
                                values.CandAdd &&
                                values.Objet === OBJECT.COLLABORATEUR;
                        },
                    },
                    {
                        xs: 6,
                        label: 'Groupe',
                        name: 'GroupeId',
                        type: 'select',
                        options: groupes,
                        show: function (values) {
                            return values.ParentId &&
                                values.CandAdd &&
                                values.Objet === OBJECT.GROUPE;
                        },
                    },
                ],
            ] }) })));
};
//# sourceMappingURL=Sectorisation.js.map